import React__default, { memo, useRef } from 'react';
import classNames from 'classnames';
import styles from './KeyboardNavigationOption.scss.mjs';
import { useKeyboardNavigation } from '../../hooks/useKeyboardNavigation.mjs';

const KeyboardNavigationOption = /*#__PURE__*/memo(function KeyboardNavigationOption({
  children,
  cover
}) {
  const nodeRef = useRef(null);
  const {
    selected
  } = useKeyboardNavigation({
    ref: nodeRef
  });
  const classes = classNames(styles.KeyboardNavigationOption, {
    [styles.selected]: selected,
    [styles.cover]: cover
  });
  return /*#__PURE__*/React__default.createElement("div", {
    ref: nodeRef,
    className: classes
  }, children);
});

export { KeyboardNavigationOption };
